import React, { useState, useEffect } from "react";
import basemapConfig from "./Basemap/basemapConfig";
import { BaseDraggable } from "./BaseDraggable";
import { useStore } from "../../stores/store";
import { DraggableKeys } from "../../interfaces/config";
import getBasemap from "../ArcGISMap/getBaseMap";
import BasemapsDropdown from "./Basemap/BasemapsDropdown";
import BasemapsSlider from "./Basemap/BasemapsSlider";
// @ts-ignore
import streetThumbnail from "./Basemap/thumbnails/streets.jpg";

const key = DraggableKeys.BASEMAP_DRAGGABLE;

export default function BasemapDraggable() {
  const { isActive, toggleActiveItem, map, config, setGlobalSelectedBasemap } =
    useStore();

  const [basemapOptions, setBasemapOptions] = useState(basemapConfig.basemaps);
  const [selectedBasemap, setSelectedBasemap] = useState(
    basemapConfig.basemaps[0],
  );

  // Sync selectedBasemap with global store
  useEffect(() => {
    if (selectedBasemap) {
      setGlobalSelectedBasemap(selectedBasemap);
    }
  }, [selectedBasemap, setGlobalSelectedBasemap]);

  useEffect(() => {
    const selectedBasemapConfig = basemapOptions.find(
      (basemap) => basemap.id === selectedBasemap?.id,
    );
    if (!selectedBasemapConfig) {
      console.error("Selected basemap configuration not found");
      return;
    }
    const newBasemap = getBasemap(selectedBasemapConfig);
    if (newBasemap && map) {
      if (selectedBasemapConfig.basemapLayers) {
        const hasAerialLayer = selectedBasemapConfig?.basemapLayers.some(
          (layer) => {
            return ["imagery", "imagery-tile"].includes(layer.type);
          },
        );

        map.layers.forEach((layer) => {
          if (layer.id === "parcels" || layer.id === "parcels-image") {
            layer.opacity = hasAerialLayer ? 0 : 1;
          }
        });

        config?.secondaryLayers?.forEach((layer) => {
          if (layer.aerialUrl && layer.aerialUrl !== "") {
            const currentLayer = map.findLayerById(layer.id);
            currentLayer.url = hasAerialLayer ? layer.aerialUrl : layer.url;
          }
        });
      }
      map.basemap = newBasemap;
    }
  }, [selectedBasemap, basemapOptions, map]);

  useEffect(() => {
    if (config?.streetsBasemap) {
      const streets = { ...config.streetsBasemap, thumbnail: streetThumbnail };
      setSelectedBasemap(streets as any);
      setBasemapOptions((prev) => [streets, ...prev]);
    }
  }, [config]);

  return (
    <BaseDraggable
      id={key}
      onClose={() => toggleActiveItem(key)}
      visible={isActive(key)}
      initialPosition="top-middle"
      className=""
      headerText="BASEMAP"
      size="md"
    >
      <p>Select Basemap:</p>
      <div>
        <p className="text-sm mt-2"></p>
        <div className="flex items-center my-2">
          <BasemapsDropdown
            options={basemapOptions}
            selectedBasemap={selectedBasemap}
            setSelectedBasemap={setSelectedBasemap}
          />
        </div>
        <BasemapsSlider
          options={basemapOptions}
          selectedBasemap={selectedBasemap}
          setSelectedBasemap={setSelectedBasemap}
        />
      </div>
    </BaseDraggable>
  );
}
